"use client";

import { Plane, Sparkles } from "lucide-react";
import type { UserOnboardingStatusResponse } from "@/@sdk/user-management/user-management.controller-models";

type WelcomeStepProps = {
  firstName: string;
  status: UserOnboardingStatusResponse;
};

export function UserWelcomeStep({ firstName, status }: WelcomeStepProps) {
  const { roleLabel, capabilities } = status.roleSummary;

  return (
    <div className="space-y-6">
      <div className="rounded-lg border bg-muted/30 p-6 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Plane className="h-6 w-6" />
        </div>
        <h3 className="text-lg font-semibold">
          Welcome to TA Desk{firstName ? `, ${firstName}` : ""}
        </h3>
        <p className="mt-2 text-sm text-muted-foreground">
          TA Desk is your travel agency workspace for enquiries, quotes,
          bookings, payments, and reporting — all in one place.
        </p>
      </div>

      <div className="space-y-3 rounded-lg border p-4">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Sparkles className="h-4 w-4 text-primary" />
          Your role: {roleLabel}
        </div>
        {capabilities.length > 0 ? (
          <ul className="space-y-1.5 text-sm text-muted-foreground">
            {capabilities.map((capability) => (
              <li key={capability} className="flex gap-2">
                <span className="text-primary">•</span>
                <span>{capability}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-muted-foreground">
            You can start collaborating with your team right away.
          </p>
        )}
      </div>

      <div className="aspect-video rounded-lg border bg-muted flex items-center justify-center">
        <p className="text-sm text-muted-foreground">Demo video coming soon</p>
      </div>
    </div>
  );
}
